import delegate from "delegate-it";
import { fireEvent } from "../common/util";

const siteMenu = document.querySelector(".site-menu");
const menu = document.querySelector("[data-menu]");

const moveMenuNext = ({ target }) => {
  const menuItem = target.closest(".site-menu-item");
  const nextSubmenu = menuItem.querySelector("[data-submenu]");
  const level = nextSubmenu.dataset.submenu;
  menuItem.classList.add("is-active");
  menu.style.setProperty("--current-level", level);

  siteMenu.classList.add("has-level");
};

const moveMenuPrev = ({ target }) => {
  const menuItem = target.closest(".site-menu-item");
  const currentSubmenu = menuItem.querySelector("[data-submenu]");
  const level = parseInt(currentSubmenu.dataset.submenu);
  const newLevel = level - 1;

  if (newLevel === 0) {
    siteMenu.classList.remove("has-level");
  }

  menu.style.setProperty("--current-level", newLevel);
  menuItem.classList.remove("is-active");
};

const handleClose = () => {
  fireEvent("slidetoggle:reset", menu.querySelectorAll('[data-slide-toggle][aria-expanded="true"]'));

  setTimeout(() => {
    menu.style.setProperty("--current-level", 0);
    siteMenu.classList.remove("has-level");
  }, 250);
};

export default {
  init: () => {
    delegate(".site-menu [data-menu-next]", "click", moveMenuNext);
    delegate(".site-menu [data-menu-prev]", "click", moveMenuPrev);
    delegate("html", "sitemenu:close", handleClose);
  },
};
